import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import type { EvaluationMethod } from '@routes/sidebar/___shared___/types';

export const STATISTICS_TYPES = {
    Minutes: 'Minutes',
    Pathways: 'Pathways',
    Elements: 'Elements',
} as const;

export const STATISTIC_DATERANGES = {
    Week: 'Week',
    Month: 'Month',
    Quarter: 'Quarter',
    Year: 'Year',
    Day: 'Day',
    Hour: 'Hour',
} as const;

export const EVALUATION_METHOD = {
    ObservedPracticalDemonstrationOnboard: 'ObservedPracticalDemonstrationOnboard',
    ReviewedSubmittedEvidence: 'ReviewedSubmittedEvidence',
    TheoreticalKnowledgeVerified: 'TheoreticalKnowledgeVerified',
    SupervisorObservationConfirmed: 'SupervisorObservationConfirmed',
} as const;

export const EVALUATION_METHOD_PILL_LABELS: Record<EvaluationMethod, MessageDescriptor> = {
    [EVALUATION_METHOD.ObservedPracticalDemonstrationOnboard]: msg`Observed onboard`,
    [EVALUATION_METHOD.ReviewedSubmittedEvidence]: msg`Evidence reviewed`,
    [EVALUATION_METHOD.TheoreticalKnowledgeVerified]: msg`Knowledge verified`,
    [EVALUATION_METHOD.SupervisorObservationConfirmed]: msg`Supervisor confirmed`,
};

export const TASK_SCALE_TYPE = {
    TwoPointApprove: 'TwoPointApprove',
    FivePointCompetence: 'FivePointCompetence',
    TwoPointConfidence: 'TwoPointConfidence',
} as const;
